import { EVENTS } from '@archetype-themes/utils/events'

class GiftMessageFormHeader extends HTMLElement {
  constructor(giftMessageFormEl) {
    super()

    const giftMessageFormId = this.getAttribute('form_id');
    this.giftMessageForm = document.getElementById(giftMessageFormId);
    this.hasGiftMessageCtaBlock = this.querySelector('.js-has-gift-message');
    this.newGiftMessageCtaBlock = this.querySelector('.js-add-gift-message');
    this.giftMessageEditBtns = this.querySelectorAll('.js-cart-gift-message-edit');
    this.clearGiftMessageFormBtn = this.querySelector('.js-cart-gift-message-delete');
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  connectedCallback() {
    this.abortController = new AbortController()

    document.addEventListener(EVENTS.cartGiftMessageUpdated, this.handleGiftMessageUpdate.bind(this), { signal: this.abortController.signal });
    document.addEventListener(EVENTS.cartGiftMessageFormClose, this.hideGiftMessageForm.bind(this), { signal: this.abortController.signal });
    this.giftMessageEditBtns.forEach(el => el.addEventListener('click', this.showGiftMessageForm.bind(this), { signal: this.abortController.signal }));

    this.clearGiftMessageFormBtn.addEventListener('click', () => {
      this.giftMessageForm.dispatchEvent(new CustomEvent(EVENTS.cartGiftMessageFormClear));
    }, { signal: this.abortController.signal});
  }

  showGiftMessageForm() {
    this.giftMessageForm.classList.remove('hide');

    document.dispatchEvent(new CustomEvent(EVENTS.cartGiftMessageFormOpen));
  }

  hideGiftMessageForm() {
    this.giftMessageForm.classList.add('hide');
  }

  handleGiftMessageUpdate({ detail: { hasGiftMessage }}) {
    if (hasGiftMessage) {
      this.newGiftMessageCtaBlock.classList.add('hide');
      this.hasGiftMessageCtaBlock.classList.remove('hide');
    } else {
      this.newGiftMessageCtaBlock.classList.remove('hide');
      this.hasGiftMessageCtaBlock.classList.add('hide');
    }

    this.hideGiftMessageForm();
  }
}

customElements.define('gift-message-form-header', GiftMessageFormHeader)